// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/global.css
// module id = 903
// module chunks = 37